<template>
  <v-fade-transition>
    <div v-if="show" class="shifft-module-loader" transition="slide-y-transition">
      <v-layout row align-end pb-3>
        <v-progress-circular :size="100" :width="12" color="primary" indeterminate></v-progress-circular>
      </v-layout>
      <v-layout row>
        <h1 v-if="hasMessage">{{message}}</h1>
      </v-layout>
    </div>
  </v-fade-transition>
</template>

<style>
  .shifft-module-loader {
    position: fixed;
    display: flex;
    flex-direction:column;
    align-items: center;
    justify-content: center;
    background-color: rgba(229, 2, 120, 0.5);
    height: 100%;
    width: 100%;
    z-index:305;
  }
</style>

<script>
  export default {
    props: ['when', 'message'],

    computed: {
      show() {
        return this.when === true;
      },
      hasMessage() {
        return this.message !== undefined && this.message !== '' && this.message !== false && this.message !== null;
      }
    }
  }
</script>
